import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDataGridModule } from 'devextreme-angular';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import { Store } from 'devextreme/data';
import { getDataSourceFilteredAndSortedData } from 'src/app/helpers/dx-utils';

@Component({
    selector: 'app-data-grid',
    imports: [
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
    ],
    templateUrl: './data-grid.component.html',
    styleUrls: ['./data-grid.component.scss'],
	standalone: true
})
export class DataGridComponent implements OnInit {
	@Input()
	public dataSource: DataSource | DataSourceOptions | Store | null | string | Array<any>;

	//#region [Expand/Collapse]
	@Input()
	public columnAutoWidth: boolean = true;
	
	public toggleColumnAutoWidth() {
		this.columnAutoWidth = !this.columnAutoWidth;
	}
	//#endregion

	//#region [height]
	private heights: number[] = [400, 700, 1000];
	private heightIndex: number = 0;
	
	@Input()
	public initialHeight: number | Function | string | undefined = 400;
	public height: number | Function | string | undefined;

	public changeHeight() {
		this.heightIndex = (this.heightIndex + 1) % this.heights.length;
		this.height = this.heights[this.heightIndex];
	}
	//#endregion

	//#region [Cell]
	@Output()
	public onCellPrepared: EventEmitter<any> = new EventEmitter<any>()

	public onCellPreparedProcess(evt) {
		evt.cellElement.style.padding = '5px';

		this.onCellPrepared.emit(evt);
	}
	//#endregion

	//#region [Toolbar]
	@Output()
	public onToolbarPreparing: EventEmitter<any> = new EventEmitter<any>();

	public onToolbarPreparingProcess(evt: any) {
		evt.toolbarOptions.items.unshift(
			{
				location: "before",
				template: "expandButtonTemplate",
			},
			{
				location: 'before',
				template: 'heightButtonTemplate'
			},
		);

		this.onToolbarPreparing.emit(evt);
	}
	//#endregion

	//#region [Content Ready]
	@Output()
	public onContentReady: EventEmitter<any> = new EventEmitter<any>();

	public rowCountText: string;

	public onContentReadyProcess(evt) {
		const data = evt.component.option('dataSource');

		if (data) {
			getDataSourceFilteredAndSortedData(
				evt.component,
				(data) => {
					for (let a = 0; a < data.length; a++) {
						const element = data[a];
						
						element.__rowIndex = a + 1;
					}

					const visibleRows = evt.component.getVisibleRows();

					this.rowCountText = `${visibleRows.length > 0 ? visibleRows[0].data.__rowIndex : 0} / ${data ? data.length : 0}`;
				}
			);
		}

		this.onContentReady.emit(evt);
	}
	//#endregion

	//#region [Selection]
	@Output()
	public onSelectionChanged: EventEmitter<any> = new EventEmitter<any>();
	//#endregion

	ngOnInit() {
		this.height = this.initialHeight;
	}
}